import get from 'lodash/get';
import { types } from './actionTypes';

export const setRoomRankerConfigLoading = (loading) => ({
  type: types.SET_ROOM_RANKER_CONFIG_LOADING,
  payload: { loading }
});

export const startFetchingRoomRankerConfig = () => {
  return {
    type: types.SET_ROOM_RANKER_CONFIG_LOADING,
    payload: {
      loading: true
    }
  };
};
export const successFetchingRoomRankerConfig = payload => {
  return {
    type: types.SET_ROOM_RANKER_CONFIG,
    payload
  };
};

export const fetchRoomRankerConfig = () => dispatch => {
  dispatch(startFetchingRoomRankerConfig());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      queryParams: {
        page_type: 'room_ranker',
        campaign: 'config'
      }
    },
    onSuccess: ({ data }) => {
      const widgetList = get(data, 'data.widget_list[0].contents.contents',[]);
      dispatch(successFetchingRoomRankerConfig(widgetList));
      dispatch(setRoomRankerConfigLoading(false));
    },
    onError: () => {
      dispatch(setRoomRankerConfigLoading(false));
    }
  });
};
